import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    task: null,
    pasteTask: false,
};
const clipboardSlice = createSlice({
    name: 'clipboard',
    initialState,
    reducers: {
        setClipboardTask: (state, action) => {
            state.task = action.payload;
        },
        setPasteTask: (state, action) => {
            state.pasteTask = action.payload;
        },
    },
    selectors: {
        selectClipboardTask: (state) => state.task,
        selectPasteTask: (state) => state.pasteTask,
    },
});
export const { setClipboardTask, setPasteTask } = clipboardSlice.actions;
export const { selectClipboardTask, selectPasteTask } = clipboardSlice.selectors;
export default clipboardSlice.reducer;
